// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"ToolTip_tooltipWrapper__xd8vq","tooltipBox":"ToolTip_tooltipBox__oVHQh","tooltipArrow":"ToolTip_tooltipArrow__xKyE1"};